import ApplicationSerializer from 'eflex/serializers/application';

export default class BomVariableSerializer extends ApplicationSerializer {
  attrs = {
    bomSource: {
      serialize: false,
      deserialize: false,
    },
  };
}
